import React from 'react';

import './modal.css';

export function Modal<I>({
    Content,
    input,
    remove,
}: ModalProps<I>): JSX.Element {
    return (
        <div className="modal-content fixed h-screen w-screen grid justify-center items-center overflow-auto">
            <Content input={input} remove={remove} />
        </div>
    );
}
